<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import { AccountApplication, AccountApplicationStatus } from "@shared/types/AccountApplication";
  import { onMount } from "svelte";
  import Header from "./Header.svelte";
  import Step1 from "./Steps/Step1.svelte";
  import Step2 from "./Steps/Step2.svelte";
  import Step3 from "./Steps/Step3.svelte";

  export let id: number = null;
  export let application: AccountApplication = <AccountApplication>{};
  export let step: number;
  export let formDisabled: boolean = ![
    AccountApplicationStatus.in_progress,
    AccountApplicationStatus.awaiting_signature,
  ].includes(application.status);

  const exitForm = () => {
    window.location.href = "/settings/accounts?tab=applications";
  };

  const goToNextStep = (id: number, nextStep: number) => {
    window["stateService"].go("layout.apply", { id: id, step: nextStep });
    window.scrollTo(0, 0);
  };

  onMount(() => {
    if (!step) {
      switch (application.status) {
        case AccountApplicationStatus.in_progress:
          step = 1;
          break;
        case AccountApplicationStatus.awaiting_signature:
          step = 2;
          break;
        case AccountApplicationStatus.verification_required:
          step = 3;
          break;
        default:
          step = 1;
      }
    }
  });

</script>

<FizzStyles>
  <div class="fizz-layout-primary">
    <Header />
    {#if step === 3}
      <Step3 bind:application {id} {step} />
    {:else if step === 2}
      <Step2 {exitForm} {goToNextStep} {id} bind:application {step} {formDisabled} />
    {:else}
      <Step1 {exitForm} {goToNextStep} {id} bind:application {step} {formDisabled} />
    {/if}
  </div>
</FizzStyles>
